/* ==========================================================================
   CELZEUS — Subtle motion layer (loader)
   Safely progressive. No-ops for reduced-motion users and old browsers.
   ========================================================================== */
(function () {
  "use strict";

  var doc = document;
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return;
  if (!("IntersectionObserver" in window)) return;

  // Selectors that should fade-up on scroll. Keep this list conservative —
  // we animate structural blocks, not every <p>.
  var REVEAL_SELECTORS = [
    "[data-celzeus-reveal]",
    "section[class*='__'] > *:not(style):not(script)",
    ".hero-video__content > *",
    ".hero-split__content > *",
    ".hero-about__content > *",
    ".hero-science__content > *",
    ".hero-research__content > *",
    ".hero-product__content > *",
    "[class$='__heading']",
    "[class$='__subheading']",
    "[class$='__overline']",
    "[class$='__body']",
    "[class$='__description']",
    "[class$='__card']",
    "[class$='__item']",
    "[class*='__grid'] > *",
    "[class*='__cards'] > *",
    "[class*='__list'] > *"
  ];

  // Skip selectors — elements we do not want to animate
  var SKIP = [
    "header",
    "footer",
    ".celzeus-header",
    ".celzeus-header *",
    ".celzeus-footer",
    ".celzeus-footer *",
    ".cart-drawer",
    ".cart-drawer *",
    ".predictive-search",
    ".predictive-search *",
    ".mobile-facets",
    ".mobile-facets *",
    "[data-celzeus-no-reveal]",
    "[data-celzeus-no-reveal] *",
    ".shopify-section[id*='header']",
    ".shopify-section[id*='header'] *",
    ".shopify-section[id*='footer']",
    ".shopify-section[id*='footer'] *",
    // --- Exclude sections that rely on cross-section z-index straddling.
    // Applying `transform` via .celzeus-reveal creates a new stacking
    // context and traps child z-indexes, which breaks the Why-Matters
    // card that overlaps into the Designed-Physiology beige peek-up.
    "[class*='why-matters-']",
    "[class*='why-matters-'] *",
    ".why-matters__inner",
    ".why-matters__inner *",
    ".why-matters__image-strip",
    ".why-matters__image-strip *",
    "[class*='designed-physiology']",
    "[class*='designed-physiology'] *"
  ];

  function matches(el, selectors) {
    if (!el || el.nodeType !== 1) return false;
    for (var i = 0; i < selectors.length; i++) {
      try {
        if (el.matches(selectors[i])) return true;
      } catch (e) { /* bad selector, ignore */ }
    }
    return false;
  }

  function collectTargets() {
    var set = new Set();
    for (var i = 0; i < REVEAL_SELECTORS.length; i++) {
      var list;
      try { list = doc.querySelectorAll(REVEAL_SELECTORS[i]); }
      catch (e) { continue; }
      for (var j = 0; j < list.length; j++) {
        var el = list[j];
        if (matches(el, SKIP)) continue;
        // Skip tiny or hidden elements
        if (el.offsetParent === null && el.tagName !== "SECTION") continue;
        set.add(el);
      }
    }
    return Array.from(set);
  }

  function tag(el, i) {
    if (el.classList.contains("celzeus-reveal")) return;
    el.classList.add("celzeus-reveal");
    // Stagger by up to 120ms per sibling group
    var siblingIndex = 0;
    var sib = el.previousElementSibling;
    while (sib) {
      if (sib.classList && sib.classList.contains("celzeus-reveal")) siblingIndex++;
      sib = sib.previousElementSibling;
    }
    var delay = Math.min(siblingIndex, 6) * 130;
    if (delay) el.style.setProperty("--celzeus-reveal-delay", delay + "ms");
  }

  function run() {
    var targets = collectTargets();
    if (!targets.length) return;

    targets.forEach(tag);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.08
    });

    targets.forEach(function (el) { io.observe(el); });

    // Fallback: flip everything visible after 2.5s so nothing stays hidden
    // if an observer edge-case misfires
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add("is-visible"); });
    }, 2500);
  }

  // Soft page fade-in
  function pageIn() {
    doc.body.classList.add("celzeus-animate-in");
  }

  // Cart pulse when the bubble count changes
  function watchCart() {
    var bubbles = doc.querySelectorAll(".cart-count-bubble");
    if (!bubbles.length) return;
    bubbles.forEach(function (b) {
      var mo = new MutationObserver(function () {
        b.setAttribute("data-celzeus-pulse", "");
        setTimeout(function () { b.removeAttribute("data-celzeus-pulse"); }, 500);
      });
      mo.observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", function () {
      pageIn(); run(); watchCart();
    });
  } else {
    pageIn(); run(); watchCart();
  }
})();
